export default "__VITE_ASSET__mgcdQ8oD__"